import React from "react";
import { useApiGet } from "../../utils/api";
import { Link } from "react-router-dom";

export const AdminHome: React.FC = () => {
  const { data, unavailable } = useApiGet("/api/admin/dashboard");

  if (unavailable) {
    return unavailable;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Admin</h1>
      <div className="row g-4">
        <div className="col-12 col-md-6 col-lg-3">
          <Link to="/admin/users" className="card-title fs-24 black">
            <div className="card">
              <div className="card-body">
                Users
                <p className="card-text display-4">{data.users_count}</p>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <Link to="/admin/boards" className="card-title fs-24 black">
            <div className="card">
              <div className="card-body">
                Boards
                <p className="card-text display-4">{data.boards_count}</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};
